<template>
  <div :style="cssVariablesBinding" data-x="html" data-x-toggle="html-overflow-hidden">
    <Theme8BaseTheHeader />

    <div v-if="shouldShowComponent" id="msgboxxWidget" />

    <main>
      <slot />
    </main>

    <Theme8BaseTheFooter />
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import IndexGlobal from '~/mixins/index.global';
import LayoutsMixin from '~/mixins/layouts.mixin';
import { useWebsiteStore } from '~/units/website/store';
import AvailableComponentsForTheme8 from '~/components/theme8/AvailableComponentsForTheme8.vue';
import { useAppMode } from '~/composables';

export default defineNuxtComponent({
  name: 'Theme8',

  mixins: [IndexGlobal, LayoutsMixin],

  components: { AvailableComponentsForTheme8 },

  data() {
    return {
      containers: [
        {
          name: 'BLOGS_VIEW',
          classes: 'blog-wrap5',
        },
        {
          name: 'BLOG_DETAIL_VIEW',
          classes: 'blog-wrap6',
        },
      ],
    };
  },

  head(context) {
    const appMode = useAppMode();

    if (appMode.server && context.ssrContext) {
      const websiteStore = useWebsiteStore();
      // const isRoderickThomas = websiteStore.companyKey === 'roderickthomas';
      const isRoderickThomas = false;
      const tagScripts = (() => {
        if (process.env.APP_STAGE === 'production') {
          return [
            ...websiteStore.googleTagsScripts,
            {
              key: 'company-analytics',
              type: 'text/javascript',
              src: `/trackers/${websiteStore.company?.company_key}.js`,
              async: false,
            },
          ];
        }
        return [];
      })();

      return {
        link: [
          {
            rel: 'stylesheet',
            href: `/theme8/css/theme/main.css`,
            type: 'text/css',
          },
          {
            rel: 'stylesheet',
            href: `/theme8/css/theme/vendors.css`,
            type: 'text/css',
          },
          {
            rel: 'stylesheet',
            href: `/theme8/css/${websiteStore.company?.company_key}/index.css`,
            type: 'text/css',
            fetchPriority: 'low',
          },

          isRoderickThomas
            ? {
                rel: 'stylesheet',
                href: 'https://cdn.msgboxx.io/static/css/bundle.min.css',
                type: 'text/css',
              }
            : null,
        ],
        script: [
          ...tagScripts,
          isRoderickThomas
            ? {
                src: 'https://cdn.msgboxx.io/static/js/bundle.min.js',
                async: true,
                onload: "window.msgboxxClient='RODERICKTHOMAS';",
                body: true,
              }
            : null,
          isRoderickThomas
            ? {
                src: `https://assets.calendly.com/assets/external/widget.js`,
                type: 'text/javascript',
                async: true,
              }
            : null,
          {
            src: `/theme8/js/theme/vendors.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme8/js/theme/main.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme8/js/${websiteStore.company?.company_key}/index.js`,
            type: 'text/javascript',
            async: false,
          },
        ],
      };
    }
  },

  computed: {
    ...mapState(useWebsiteStore, ['currentPage', 'company']),

    cssVariablesBinding() {
      return {
        ...this.cssVariables,
        '--c-primary': this.colors.primary || '#606B4D',

        '--akya-text-color': 'var(--c-text-primary)',
        '--akya-background-color': 'var(--c-section_primary)',
        '--akya-confirm-button-text-color': 'var(--c-text-secondary)',
        '--akya-confirm-button-background-color': 'var(--c-primary)',
      };
    },

    isRoderickThomas() {
      /* return useWebsiteStore().companyKey === 'copeandco'; */
      return false;
    },

    shouldShowComponent() {
      const currentPath = this.$route.path;
      const isInHeadsUpAlerts = currentPath.startsWith('/heads-up-alerts');
      return this.isRoderickThomas && !isInHeadsUpAlerts;
    },
  },
});
</script>
